module.exports = __webpack_public_path__ + "static/images/bp-s-bg2.7ebe007.png";